// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NVXw","comment":"styles_comment__35uEB"};